import Vue from 'vue'
import router from '@router/index'
import store from '@store/index'
import storage from '@js/storage.js'
import config from '@config/index'

// import NAV from '@/config/nav'

// const ORIDINARY_MENU = NAV;

const ORIDINARY_NAV_DROP_DOWN = [
    {
        text: '退出登录',
        icon: 'el-icon-switch-button',
        command: () => {
            Vue.prototype.$get(`${store.getters.ageUrl}/admin/revision/logout.json`, () => {
                var user = storage.getSession('user')
                store.commit('setUser', {});
                store.commit('setSystem', {});
                store.commit('agency/setNavList', '');
                store.commit('setBread', []);
                storage.setSession('menu', []);
                storage.setSession('ishbdx', '');
                // 返回旧系统登录(代理)
                if(user.identityType==='T'){
                    window.location.href = 'http://'+window.location.host + '/admin/tender/login'
                }else{
                    window.location.href = 'http://'+window.location.host + '/admin/login'
                    // window.location.href = 'http://'+window.location.host + '/#/login'
                }
                
            });
        }
    }
]

export default {
    namespaced: true,
    state: {
        system: 'views',
        navDropDown: ORIDINARY_NAV_DROP_DOWN,
        topNavRightBtns: [
            {
                text: '切换到新版',
                icon: 'el-icon-sort',
                click() {
                    router.push('/home');
                }
            },
            {
                text: '返回桌面',
                icon: 'el-icon-s-home',
                click() {
                    router.push({
                        path: '/iframe',
                        query: {
                            url: '/admin/index'
                        } 
                    });
                }
            },
            {
                text: '提交工单',
                icon: 'el-icon-price-tag',
                click() {
                    router.push('/manage/business/xgsq/list');
                }
            }
        ],
        navList: storage.getSession('menu')
    },
    mutations: {
        setNavList(state, n) {
            state.navList = n;
            storage.setSession('menu', n);
        },
        setNavDropDown(state, n) {
            state.navDropDown = n;
        }
    },
    actions: {
        login({state, dispatch}, {obj}) {
            Vue.prototype.$get(`${store.getters.ageUrl}/admin/getIdentity.json`, { 
            },function(data, res) {
                if(data!==null) {
                    for(var i = 0;i<data.length;i++) {
                        if(data[i].configname=='ishbdx'&&data[i].configvalue=='1') {
                            setSession('ishbdx',data[i].configvalue)
                        }
                    }
                }
            })
            // store.commit('setUser', data);
            store.commit('setSystem', {
                type: state.system,
            });

            dispatch('updateNavDropDown');
            dispatch('queryUserInfo');

            router.replace({
                path: '/home'
                // path: '/bidding/workbench/index'
            });
                
        },
        // CA登录
        
        queryUserInfo({state, dispatch}, requery) {
            // if(!requery) {
            //     var userInfo = store.getters.user;
            //     if(Object.keys(userInfo).length) {
            //         dispatch('updateNavDropDown', userInfo);
            //         return;
            //     };
            // };
            Vue.prototype.$get(`${store.getters.ageUrl}/admin/index.json?q=Q`, data => {
                // 重定向
                if(data.JumpTender){
                    window.location.href = data.tenderSysIndexUrl
                }
                store.commit('setUser', data);
                store.commit('setSystem', {
                    type: state.system,
                    api: store.getters.ageUrl
                });
                
                dispatch('updateNavDropDown');
                dispatch('getMenu',data.menuList);
            });
        },
        getMenu({commit, state},item) {
            // Vue.prototype.$get(`${store.getters.ageUrl}/tree/get_menu.json`, data => {
            //     var menu = [];

            //     menu.push.apply(menu, ORIDINARY_MENU);
            //     var menuList = clone(menu);
            //     menuList.push.apply(menuList, data);

            //     commit('setNavList', menuList);
            // });
            var menuList = [];
            menuList.push.apply(menuList, item);

            commit('setNavList', menuList);
        },
        updateNavDropDown({commit, state}) {
            var navDropDown = clone(ORIDINARY_NAV_DROP_DOWN);
            commit('setNavDropDown', navDropDown);
        }
    }
};